import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Header, Modal, Form, Grid } from 'semantic-ui-react';
import { Field, reduxForm, getFormValues } from 'redux-form';

import {
  InputTypes,
  StatusNames,
  MealTypeNames,
} from '../../helpers/EditDailyDepositHelpers';
import { InputField } from 'Common/SemanticWrapper';
import { EDIT_DAILY_DEPOSIT_SALES_TABLE_MODAL_FORM_NAME } from 'Common/FormEnum';
import { YesNoDialog } from 'Components/';

class EditCellModalForm extends Component {
  static props = {
    isFreeStudent: PropTypes.bool.isRequired,
    prefix: PropTypes.string.isRequired,
    statusId: PropTypes.string.isRequired,
    isMeals: PropTypes.bool.isRequired,
    okCallback: PropTypes.func.isRequired,
    cancelCallback: PropTypes.func.isRequired,
  };

  state = {
    yesNoDialog: null,
    doneFreeSalesValueCheck: false,
  };

  fieldsLayout = [
    [
      {
        label: this.props.isMeals ? 'Federal Qty' : 'Supp Qty',
        inputType: InputTypes.Qty,
        detail: 'Detail1',
        extra: {},
      },
      {
        label: this.props.isMeals ? 'Federal Sales ($)' : 'Supp Sales ($)',
        inputType: InputTypes.Sales,
        detail: 'Detail1',
        extra: {},
      },
    ],
    [
      {
        label: this.props.isMeals ? 'State Qty' : 'Milk Qty',
        inputType: InputTypes.Qty,
        detail: 'Detail2',
        extra: {},
      },
      {
        label: this.props.isMeals ? 'State Sales ($)' : 'Milk Sales ($)',
        inputType: InputTypes.Sales,
        detail: 'Detail2',
        extra: {},
      },
    ],
    [
      {
        label: 'Total',
        inputType: InputTypes.Qty,
        detail: '',
        extra: { disabled: true },
      },
      {
        label: 'Total ($)',
        inputType: InputTypes.Sales,
        detail: '',
        extra: { disabled: true },
      },
    ],
  ];

  openYesNoCallback = () => {
    return new Promise((resolve, reject) => {
      this.setState({
        yesNoDialog: {
          yesCallback: () => {
            resolve();
            this.setState({ yesNoDialog: null, doneFreeSalesValueCheck: true });
          },
          noCallback: () => {
            reject();
            this.setState({ yesNoDialog: null });
          },
        },
      });
    });
  };

  render() {
    const {
      cancelCallback,
      statusId,
      prefix,
      change,
      formValues,
      isFreeStudent,
      isMeals,
    } = this.props;
    const { yesNoDialog, doneFreeSalesValueCheck } = this.state;

    return (
      <Modal open closeIcon onClose={cancelCallback}>
        <Header
          content={`${StatusNames[statusId]} - ${MealTypeNames[prefix]}`}
        />
        <Modal.Content>
          {yesNoDialog && (
            <YesNoDialog
              showDialog={true}
              title={'Free'}
              question={'Free sales values should always be 0. Are you sure?'}
              {...yesNoDialog}
            />
          )}

          <Form onSubmit={() => {}}>
            <Grid textAlign={'left'}>
              {this.fieldsLayout.map((row, index) => (
                <Grid.Row columns={2} key={index}>
                  {row.map((cell, index) => {
                    const inputId = `${prefix}${cell.inputType.name}${
                      cell.detail
                    }`;
                    return (
                      <Grid.Column key={index}>
                        <Field
                          fluid
                          type={'number'}
                          numericSize={[8, 2]}
                          mode={cell.inputType.mode}
                          name={inputId}
                          component={InputField}
                          label={cell.label}
                          formatOnBlur={cell.inputType.formatter}
                          handleBlur={async (e, value) => {
                            if (
                              isMeals &&
                              !doneFreeSalesValueCheck &&
                              isFreeStudent &&
                              cell.inputType === InputTypes.Sales &&
                              value > 0
                            ) {
                              try {
                                await this.openYesNoCallback();
                              } catch (error) {
                                change(
                                  `${prefix}${cell.inputType.name}${
                                    cell.detail
                                  }`,
                                  cell.inputType.formatter(0)
                                );
                                return;
                              }
                            }
                            // if isMeals then total is the same as Detail1 otherwise total is Detail1 + Detail2
                            if (isMeals) {
                              if (cell.detail === 'Detail1')
                                change(
                                  `${prefix}${cell.inputType.name}`,
                                  value
                                );
                            } else {
                              const detail1 = Number(
                                formValues[
                                  `${prefix}${cell.inputType.name}Detail1`
                                ]
                              );
                              const detail2 = Number(
                                formValues[
                                  `${prefix}${cell.inputType.name}Detail2`
                                ]
                              );
                              change(
                                `${prefix}${cell.inputType.name}`,
                                cell.inputType.formatter(detail1 + detail2)
                              );
                            }
                          }}
                          {...cell.extra}
                        />
                      </Grid.Column>
                    );
                  })}
                </Grid.Row>
              ))}
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            inverted
            color="orange"
            size="big"
            content="OK"
            onClick={this.props.submit}
            disabled={this.props.invalid}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const { prefix, isMeals } = props;

  for (const key in values) {
    if (values[key].length > 8) {
      errors[key] = `The value is too big.`;
    }
  }

  if (isMeals) {
    const fedQuantity = Number(
      values[`${prefix}${InputTypes.Qty.name}Detail1`]
    );
    const fedSales = Number(values[`${prefix}${InputTypes.Sales.name}Detail1`]);
    const stateQuantity = Number(
      values[`${prefix}${InputTypes.Qty.name}Detail2`]
    );
    const stateSales = Number(
      values[`${prefix}${InputTypes.Sales.name}Detail2`]
    );

    if (stateQuantity > fedQuantity) {
      errors[
        `${prefix}${InputTypes.Qty.name}Detail2`
      ] = `The State quantity cannot be greater than the Federal quantity.`;
    }
    if (stateSales > fedSales) {
      errors[
        `${prefix}${InputTypes.Sales.name}Detail2`
      ] = `The State sales amount cannot be greater than the Federal sales amount.`;
    }
  }

  return errors;
};

const handleSubmit = (values, dispatch, props) => props.okCallback(values);

const mapStateToProps = (state, ownProps) => {
  return {
    formValues: getFormValues(EDIT_DAILY_DEPOSIT_SALES_TABLE_MODAL_FORM_NAME)(
      state
    ),
  };
};

export const EditCellModal = connect(
  mapStateToProps,
  {}
)(
  reduxForm({
    form: EDIT_DAILY_DEPOSIT_SALES_TABLE_MODAL_FORM_NAME,
    validate,
    onSubmit: handleSubmit,
  })(EditCellModalForm)
);



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/components/sales/EditCellModal.js